import React from "react";
import Select from "react-select";

import { bgColor } from "./Colors";
import { Smallcaps } from "./Prose";

export const Facet = ({ color, children, handleOnClick, ...rest }) => (
  <div
    {...rest}
    className={`inline-flex items-center mr-4 mt-4 px-4 py-2 text-sm font-medium leading-5 text-black   transition duration-200 ease-in-out transform hover:scale-105 cursor-pointer ${bgColor(
      color
    )}`}
    onClick={handleOnClick}
  >
    {children}
  </div>
);

export const Facets = ({ color, setter, filters, facets, getKey, getName }) =>
  facets ? (
    <div className="flex flex-wrap justify-center">
      <Facet handleOnClick={() => setter([])} color="gray">
        All
      </Facet>
      {facets?.map((fac) => (
        <Facet
          handleOnClick={() => {
            filters && filters?.includes(getKey(fac))
              ? setter(filters?.filter((f) => f !== getKey(fac)))
              : setter((filters || []).concat(getKey(fac)));
          }}
          key={getKey(fac)}
          color={color(fac)}
        >
          {filters?.includes(getKey(fac)) && (
            <svg
              className="flex-shrink-0 mr-1.5 h-5 w-5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          )}
          {getName(fac)}
        </Facet>
      ))}
    </div>
  ) : null;

export const Filters = ({ facets, filters, setter }) => (
  <div className="space-y-3 text-gray-700">
    <Smallcaps>Search & Filters</Smallcaps>
    <Select
      isMulti
      placeholder="Select multiple filters to refine your search"
      value={filters?.map((text) => ({ label: text, value: text }))}
      options={facets}
      filterOptions={{ ignoreCase: true, ignoreAccents: true, trim: true }}
      onChange={(values) => {
        setter(values?.map((v) => v.value));
      }}
    />
  </div>
);
